import axios from "axios";
import { toast } from "react-toastify";
import {
  BookedSlot,
  CourseWhishListData,
  setCourseSlots,
  STATUSES,
} from "../Reducers/CourseSlice";
import {
  SetAllCoursesData,
  setStatus,
  setcourseImage,
  setcourseMainImage,
  SetCourseDetails,
  SetCatagoriesData,
  SetCourseReview,
  SetCourseExpertData,
  SetCourseScheduleData,
  SetStudentCourseData,
} from "../Reducers/CourseSlice";
const apiUrl = process.env.REACT_APP_API_URL;

export function UploadFile(formdata, Token, type) {
  return async function File(Dispatch, getState) {
    try {
      const res = await axios.post(`${apiUrl}upload/image`, formdata, {
        headers: {
          Authorization: `Bearer ${Token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data.errorCode === 200) {
        const uploadedImagePath = res.data?.data[0];

        if (type === "courseImage") {
          Dispatch(setcourseImage(uploadedImagePath));
        } else {
          Dispatch(setcourseMainImage(uploadedImagePath));
        }
        return uploadedImagePath;
      } else {
        toast.error(res?.data?.errorMessage);
      }
    } catch (e) {
      console.log(e);
    }
  };
}
export function CreateCourse(data, Token, action) {
  return async function File(Dispatch, getState) {
    Dispatch(setStatus(STATUSES.LOADING));
    try {
      const res = await axios.post(`${apiUrl}Courses/Save`, data, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });

      if (res.data.errorCode === 200) {
        Dispatch(setStatus(STATUSES.IDLE));
        toast.success(res.data.errorMessage);
        action.resetForm();
      } else {
        toast.error(res.data.errorMessage);
      }
    } catch (e) {
      Dispatch(setStatus(STATUSES.ERROR));
      console.log(e);
    }
  };
}
export function CourseDelete(Token, Id, setUpdateCourseState) {
  return async function AllCourses(Dispatch) {
    try {
      const res = await axios.post(
        `${apiUrl}Courses/Delete?id=${Id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }
      );
      setUpdateCourseState((prevState) => !prevState);
      toast.success(res.data.errorMessage);
    } catch (e) {
      console.log(e);
    }
  };
}

export function GetAllCourses() {
  return async function AllCourses(Dispatch) {
    Dispatch(setStatus(STATUSES.LOADING));
    try {
      const res = await axios.get(`${apiUrl}Courses/GetAll`);
      Dispatch(SetAllCoursesData(res?.data?.data));
      Dispatch(setStatus(STATUSES.IDLE));
    } catch (e) {
      Dispatch(setStatus(STATUSES.ERROR));
    }
  };
}
export function GetCourseByExpertId(ExpertId, Token) {
  return async function AllCourses(Dispatch) {
    Dispatch(setStatus(STATUSES.LOADING));
    try {
      const res = await axios.get(
        `${apiUrl}Courses/GetCoursesByExpertId?expertId=${ExpertId}`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }
      );
      if (res.data.errorCode === 200) {
        Dispatch(SetCourseExpertData(res?.data?.data));
        Dispatch(setStatus(STATUSES.IDLE));
      } else {
        Dispatch(SetCourseExpertData(res?.data?.data));
        Dispatch(setStatus(STATUSES.ERROR));
      }
    } catch (e) {
      Dispatch(setStatus(STATUSES.ERROR));
    }
  };
}

export function GetCoursesUpdate(UpdateCourseData, Token, action, Navigate) {
  return async function CoursesUpdate(Dispatch) {
    Dispatch(setStatus(STATUSES.LOADING));
    try {
      const res = await axios.put(`${apiUrl}Courses/Update`, UpdateCourseData, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      Dispatch(setStatus(STATUSES.IDLE));
      toast.success(res.data.errorMessage);
      Navigate("/listofcourses");

      action.resetForm();
    } catch (e) {
      Dispatch(setStatus(STATUSES.ERROR));
    }
  };
}

export function GetCourseDetailsbyId(Id) {
  return async function AllCourses(Dispatch) {
    Dispatch(setStatus(STATUSES.LOADING));
    try {
      const res = await axios.get(`${apiUrl}Courses/GetById?Id=${Id}`);
      Dispatch(SetCourseDetails(res.data.data));
      Dispatch(setStatus(STATUSES.IDLE));
    } catch (e) {
      Dispatch(setStatus(STATUSES.ERROR));
    }
  };
}
export function GetCoursesListById(Id, Navigate) {
  return async function GetCoursesList(Dispatch) {
    Dispatch(setStatus(STATUSES.LOADING));
    try {
      const res = await axios.get(
        `${apiUrl}Courses/GetCoursesListByCategoryId?categoryid=${Id}`
      );
      if (res.data.errorCode === 200) {
        Dispatch(SetCatagoriesData(res?.data?.data));
        Navigate("/allcourses");
        Dispatch(setStatus(STATUSES.IDLE));
      } else {
        Dispatch(setStatus(STATUSES.ERROR));
      }
    } catch (e) {
      Dispatch(setStatus(STATUSES.ERROR));
    }
  };
}
export function ApiReviewsSave(formData, Token, setState) {
  return async function ApiReviewssave(Dispatch) {
    Dispatch(setStatus(STATUSES.LOADING));
    try {
      const res = await axios.post(`${apiUrl}Review/Save`, formData, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });

      if (res.data.errorCode === 200) {
        Dispatch(setStatus(STATUSES.IDLE));
        setState((prev) => !prev);
      } else {
        toast.error(res?.data?.errorMessage);
      }
    } catch (e) {
      Dispatch(setStatus(STATUSES.ERROR));
    }
  };
}
export function GetReviewsByCourseId(CourseId) {
  return async function ApiReviewssave(Dispatch) {
    Dispatch(setStatus(STATUSES.LOADING));
    try {
      const res = await axios.get(
        `${apiUrl}Review/GetReviewsByCourseId?Id=${CourseId}`
      );

      if (res.data.errorCode === 200) {
        Dispatch(setStatus(STATUSES.IDLE));
        Dispatch(SetCourseReview(res?.data?.data));
      } else {
        toast.error(res?.data?.errorMessage);
      }
    } catch (e) {
      Dispatch(setStatus(STATUSES.ERROR));
    }
  };
}
export function AddCourseSlots(savedCourseData, Token) {
  return async function AddSlots(Dispatch) {
    Dispatch(setStatus(STATUSES.LOADING));
    try {
      const res = await axios.post(
        `${apiUrl}coursesSlots/AddCourseSlots`,
        savedCourseData,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }
      );
      if (res.data.errorCode === 200) {
        toast.success(res?.data?.errorMessage);
        Dispatch(setStatus(STATUSES.IDLE));
      } else {
        toast.error(res?.data?.errorMessage);
      }
    } catch (e) {
      Dispatch(setStatus(STATUSES.ERROR));
    }
  };
}
export function CoursesScheduleSave(Data, Token) {
  return async function AddScedule(Dispatch) {
    Dispatch(setStatus(STATUSES.LOADING));
    try {
      const res = await axios.post(`${apiUrl}coursesSchedule/Save`, Data, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      if (res.data.errorCode === 200) {
        Dispatch(BookedSlot(res?.data?.data));
        Dispatch(setStatus(STATUSES.IDLE));
        toast.success(res?.data?.errorMessage);
      } else {
        toast.error(res?.data?.errorMessage);
      }
    } catch (e) {
      Dispatch(setStatus(STATUSES.ERROR));
    }
  };
}
export function CoursesSceduleUpdate(Data, Token) {
  return async function UpdateSchedule(Dispatch) {
    Dispatch(setStatus(STATUSES.LOADING));
    try {
      const res = await axios.put(`${apiUrl}/coursesSchedule/Update`, Data, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      if (res.data.errorCode === 200) {
        Dispatch(setStatus(STATUSES.IDLE));
        toast.success(res?.data?.errorMessage);
      } else {
        toast.error(res?.data?.errorMessage);
      }
    } catch (e) {
      Dispatch(setStatus(STATUSES.ERROR));
    }
  };
}
export function GetScheduleByExpertId(ExpertId, Token) {
  return async function GetSchedule(Dispatch) {
    Dispatch(setStatus(STATUSES.LOADING));
    try {
      const res = await axios.get(
        `${apiUrl}/coursesSchedule/GetScheduleListByExpertId?expertId=${ExpertId}`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }
      );
      if (res.data.errorCode === 200) {
        Dispatch(SetCourseScheduleData(res?.data?.data));
        Dispatch(setStatus(STATUSES.IDLE));
      } else {
        // toast.error(res?.data?.errorMessage);
      }
    } catch (e) {
      Dispatch(setStatus(STATUSES.ERROR));
    }
  };
}

export function GetScheduleByStudentId(studentId, Token) {
  return async function GetSchedule(Dispatch) {
    Dispatch(setStatus(STATUSES.LOADING));
    try {
      const res = await axios.get(
        `${apiUrl}/coursesSchedule/GetScheduleListByStudentId?studentId=${studentId}`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }
      );
      if (res.data.errorCode === 200) {
        Dispatch(SetStudentCourseData(res?.data?.data));
        Dispatch(setStatus(STATUSES.IDLE));
      }
    } catch (e) {
      Dispatch(setStatus(STATUSES.ERROR));
    }
  };
}

export function addWishList(Data, Token) {
  return async function AddWishListData(Dispatch) {
    Dispatch(setStatus(STATUSES.LOADING));
    try {
      const res = await axios.post(`${apiUrl}/Wishlist/Save`, Data, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      if (res.data.errorCode === 200) {
        Dispatch(setStatus(STATUSES.IDLE));
        toast.success("Successfully Done !");
      } else {
        toast.error(res?.data?.errorMessage);
      }
    } catch (e) {
      Dispatch(setStatus(STATUSES.ERROR));
    }
  };
}

export function getWishListById(studentId, Token) {
  return async function AddWishListData(Dispatch) {
    Dispatch(setStatus(STATUSES.LOADING));
    try {
      const res = await axios.get(
        `${apiUrl}/Wishlist/GetWishListByUserId?userId=${studentId}`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }
      );
      if (res.data.errorCode === 200) {
        Dispatch(setStatus(STATUSES.IDLE));
        Dispatch(CourseWhishListData(res?.data?.data));
      } else {
        Dispatch(CourseWhishListData(res?.data?.data));
      }
    } catch (e) {
      Dispatch(setStatus(STATUSES.ERROR));
    }
  };
}

export function getSlotsByCourseId(courseId, Token) {
  return async function AddWishListData(Dispatch) {
    Dispatch(setStatus(STATUSES.LOADING));
    try {
      const res = await axios.get(
        `${apiUrl}/coursesSlots/GetByCourseId?Id=${courseId}`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }
      );
      if (res.data.errorCode === 200) {
        Dispatch(setStatus(STATUSES.IDLE));
        Dispatch(setCourseSlots(res?.data?.data));
      } else {
        Dispatch(setStatus(STATUSES.IDLE));
        Dispatch(setCourseSlots(res?.data?.data));
      }
    } catch (e) {
      Dispatch(setStatus(STATUSES.ERROR));
    }
  };
}
